<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w card-01" v-loading="loading">
    <p class="w100 bold mb20 font-18 tx-c">今日大厅访问</p>
    <el-row class="mt20 count" v-if="todayData.length > 0">
      <el-col class="tx-c up down" :span="8" v-for="(item, index) in todayData" :key="index" :style="{ 'background-image': item.level == 'up' ? `url(${baseUrl}/images/icon-up.png)` : item.level == 'down' ? `url(./images/icon-down.png)` : '' }">
        <p class="grey mb10 font-14">{{ item.label }}</p>
        <p class="font-36">{{ item.value }}</p>
      </el-col>
    </el-row>
    <p class="w100 pt20 pb20 tx-c grey" v-else>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: "AllView01",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      todayData: []
    };
  },
  computed: {},
  created() {
    this.fetchToday();
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchToday() {
      this.loading = true;
      setTimeout(() => {
        this.todayData = [
          {
            label: "浏览量（PV）",
            value: 194,
            level: "up"
          },
          {
            label: "访客数（UV）",
            value: 34,
            level: "down"
          },
          {
            label: "平均访问页数",
            value: 5,
            level: ""
          }
        ];
        this.loading = false;
      }, 500);
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.card-01 {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.count .up,
.count .down {
  background: no-repeat 80% center;
  background-size: auto 60px;
}
</style>
